/* jshint esversion: 6 */
import { Assert } from "@/common/Assert";
import { LoggingService } from "@/logging/LoggingService";
import { createCmi5UIAdapter } from "./createCmi5UIAdapter";
import { createCourse } from "./Cmi5Course";
import { createGlobalApi } from "@/cmi5/globalapi/GlobalApi";
/**
 * Legacy behaviour:
 * The window.COURSE_DATA_API field is used to separate the wbt-sco -> publisher communication from the course-sco -> publisher
 * communication to keep both data sets in publisher. In order to that, on SCO launch, the sco.launch.jsp will check for
 * the window.API_1484_11 object and delegates it to the wbt as a scorm api. In case that window.API_1484_11 object is undefined, the
 * sco.launch.jsp will check for the presence of the TTKF-Publisher and instantiate a scorm api (PublisherScormApi.js) that connects the wbt
 * directly with the publisher.
 *
 * Refactoring for TTKF 20.1
 * This behaviour is now refactored and the publisher course api will provide as window.API_1484_11 and communicates with the player.
 * Unfortunately we can not remove the window.COURSE_DATA_API field, due to customer configurations will check this field to
 * assure that the course runs in a publisher scenario.
 *
 * @see ../globalapi/GlobalApi.ts
 */
const logId = "Cmi5Course";
/**
 *
 * @param options
 */
export const createCmi5Course = function (options) {
    var _a;
    LoggingService.log("check cmi5 environment...", logId);
    Assert.checkArgument(options);
    Assert.checkState(options.lmsStandard === "cmi5_1.0.3");
    Assert.checkState(options.scoExportType === "singleSco");
    Assert.checkUrlArgument("fetch");
    Assert.checkUrlArgument("endpoint");
    Assert.checkUrlArgument("actor");
    Assert.checkUrlArgument("registration");
    Assert.checkUrlArgument("activityId");
    LoggingService.log("creating course for cmi5 lms...", logId);
    const masteryScore = (_a = options.masteryScore) !== null && _a !== void 0 ? _a : 80;
    Assert.checkArgumentType(masteryScore, "number");
    const course = createCourse(masteryScore);
    const uiAdapter = createCmi5UIAdapter(course);
    course.initialize();
    createGlobalApi(course);
    // revealing public api
    return {
        getClassName: () => "Cmi5Course",
        /**
         * Gets the storage system for the course.
         *
         * @returns {string} "scorm_lms"
         */
        getStorageSystem: () => "scorm_lms",
        /**
         * Gets the storage method for the course.
         *
         * @returns {string}
         */
        getStorageMethod: () => uiAdapter.getStorageMethod(),
        /**
         * Gets the mastery score for the course.
         *
         * @returns {number} mastery score
         */
        getCourseMasteryScore: () => course.getMasteryScore(),
        /**
         * Due to the nature of the session based scorm communication
         * with the publisher, it is not allowed to start multiple
         * SCOs at the same time.
         *
         * @returns {boolean} false
         */
        isMultiScoLaunchAllowed: () => false,
        useScoLaunchParams: () => true,
        initScoreIDs: (useAssessments) => course.setScoreList(useAssessments),
        prepareSequenceLaunch: (scoId) => course.initializeActiveLearningSco(scoId),
        isSequenceConnected: () => course.hasActiveLearningSco(),
        /**
         * The current status will be committed to the LMS. And the session is terminated.
         *
         * ! Der Kurs behandelt den Status und das Schlie��en des Browsers selbst !
         */
        terminate: () => {
        },
        exit: () => {
            course.terminate();
        },
        /**
         * @deprecated
         *
         * @return {Boolean} false
         */
        handleBrowserOnTerminate: () => false,
        onSequenceTerminate: () => { },
        /**
         * DOM synchronization
         */
        getProfileController: () => uiAdapter,
        setUsername: (name) => uiAdapter.setUsername(name),
        getUsername: () => uiAdapter.getUsername(),
        initSequenceData: course.domStructure.initSequenceData,
        getSequenceData: course.domStructure.getSequenceData,
        setSequenceData: course.domStructure.setSequenceData,
        getSequenceDataMap: course.domStructure.getSequenceDataMap,
        clearSequenceDataMap: course.domStructure.clearSequenceDataMap,
        getSequenceInfos: course.domStructure.getSequenceInfos,
        getScoreIDs: course.domStructure.getScoreIDs,
        getResultMap: course.domStructure.getResultMap,
        refreshStatus: () => course.onDomAndModelSynchronized()
    };
};
